export const GET_ORGANIZATION_GROUP_START =
  'GET_ORGANIZATION_GROUP_START';
export const GET_ORGANIZATION_GROUP_SUCCESS =
  'GET_ORGANIZATION_GROUP_SUCCESS';
export const GET_ORGANIZATION_GROUP_ERROR =
  'GET_ORGANIZATION_GROUP_ERROR';
